<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isSysAdmin()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                    <br />
                    <div class="row hidden-print">
                        <!-- <button @click="exportToPDF">Export to PDF</button> -->
                        <button
                            class="btn btn-danger"
                            v-if="
                                delivery_commitment.delivery_status ==
                                'ACCEPTED BY GD'
                            "
                            onClick="window.print()"
                        >
                            Print Slip
                        </button>
                        &nbsp;
                        <button
                            class="btn btn-danger"
                            @click="
                                updateStatusModalPrompt(delivery_commitment)
                            "
                        >
                            Change Status
                        </button>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <div class="col-lg-10 hidden-print d-print-none">
            <div class="card card-danger card-outline">
                <div class="card-body overflow-auto">
                    <div class="col-sm-12">
                        <div class="row" v-if="delivery_status_timeline != ''">
                            <h5>Status Timeline &nbsp;</h5>
                            <br />
                            <p>(Will not be available in print mode)</p>
                            <table class="table">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Date &amp; Time</th>
                                        <th>Delivery Status</th>
                                        <th>Updated By</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="status in delivery_status_timeline"
                                    >
                                        <td>
                                            {{ status.created_at | timeStamp }}
                                        </td>
                                        <td>{{ status.status }}</td>
                                        <td>{{ status.user.user_detail }}</td>
                                        <td>{{ status.notes }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main content -->
        <section class="content justify-content-center" align="center">
            <div
                class="col-lg-10 justify-content-center"
                align="center"
                id="print"
            >
                <div
                    class="card justify-content-center"
                    align="center"
                    style="border:none !important; border-radius 30px !important; margin-bottom: 10px !important;"
                >
                    <div class="col-sm-12" style="padding: 2% !important">
                        <div class="row">
                            <div class="col-sm-12">
                                <div
                                    class="row justify-content-center"
                                    style="align-content: center"
                                >
                                    <h4>Delivery Commitment Slip</h4>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-sm-12">
                                        <span
                                            v-if="
                                                delivery_commitment.is_combo_order ==
                                                true
                                            "
                                            class="left badge badge-success"
                                            ><h4>COMBO</h4></span
                                        >
                                        <span
                                            v-if="
                                                delivery_commitment.is_urgent ==
                                                true
                                            "
                                            class="left badge badge-danger"
                                            ><h4>URGENT</h4></span
                                        >
                                        <span
                                            v-if="
                                                delivery_commitment.gst_bill_required ==
                                                true
                                            "
                                            class="left badge badge-danger"
                                            ><h4>GST BILL WANTED</h4></span
                                        >
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div
                                        class="col-sm-12"
                                        style="
                                            border-bottom: 2px dotted darkred !important;
                                        "
                                    ></div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-sm-6">
                                        Selling Branch:
                                        <span
                                            class="left badge badge-info border-none"
                                            ><h3>
                                                {{
                                                    delivery_commitment.branch_code
                                                }}
                                            </h3></span
                                        >
                                    </div>
                                    <div class="col-sm-6">
                                        Stock Origin:
                                        <span
                                            class="left badge badge-info border-none"
                                            ><h3>
                                                {{
                                                    delivery_commitment.linked_warehouse
                                                }}
                                            </h3></span
                                        >
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div
                                        class="col-sm-12"
                                        style="
                                            border-bottom: 2px dotted darkred !important;
                                        "
                                    ></div>
                                </div>
                                <br />
                                <br />
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h6>POS ID:</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <h6>{{ delivery_commitment.id }}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h4>GATEPASS NO:</h4>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4>
                                            {{
                                                delivery_commitment.gatepass_no
                                            }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h4>ORDER DATE:</h4>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4>
                                            {{
                                                delivery_commitment.created_at
                                                    | addedDate
                                            }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h4>CUSTOMER NAME:</h4>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4>
                                            {{
                                                delivery_commitment.customer_name
                                            }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h4>PHONE:</h4>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4>
                                            {{
                                                delivery_commitment.phone_number
                                            }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>ALTERNATE PHONE:</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            {{
                                                delivery_commitment.alt_phone_number
                                            }}
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>GST No:</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            {{ delivery_commitment.gst_no }}
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>ITEM CATEGORY:</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            <b>{{ item_category.category }}</b>
                                        </h5>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>ITEM SUMMARY:</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            ITEM 1:
                                            {{
                                                delivery_commitment.item_code_1
                                            }}
                                            -
                                            {{ delivery_commitment.product_1 }}
                                            -
                                            {{ delivery_commitment.brand_1 }} -
                                            {{ delivery_commitment.model_1 }}
                                            <br />
                                            ITEM 2:
                                            {{
                                                delivery_commitment.item_code_2
                                            }}
                                            -
                                            {{ delivery_commitment.product_2 }}
                                            -
                                            {{ delivery_commitment.brand_2 }} -
                                            {{ delivery_commitment.model_2 }}
                                            <br />
                                            ITEM 3:
                                            {{
                                                delivery_commitment.item_code_3
                                            }}
                                            -
                                            {{ delivery_commitment.product_3 }}
                                            -
                                            {{ delivery_commitment.brand_3 }} -
                                            {{ delivery_commitment.model_3 }}
                                            <br />
                                            ITEM 4:
                                            {{
                                                delivery_commitment.item_code_4
                                            }}
                                            -
                                            {{ delivery_commitment.product_4 }}
                                            -
                                            {{ delivery_commitment.brand_4 }} -
                                            {{ delivery_commitment.model_4 }}
                                        </h5>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div
                                        class="col-sm-12"
                                        style="
                                            border-bottom: 2px dotted darkred !important;
                                        "
                                    ></div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>Preferred Delivery Date:</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            {{
                                                delivery_commitment.preferred_delivery_date
                                                    | formattedDateWithOne
                                            }}
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h4>Confirmed Delivery Date:</h4>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4
                                            v-if="
                                                delivery_commitment.confirmed_delivery_date !=
                                                null
                                            "
                                        >
                                            {{
                                                delivery_commitment.confirmed_delivery_date
                                                    | formattedDateWithOne
                                            }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>Route:</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>{{ delivery_route.route }}</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>Landmark</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            {{ delivery_commitment.landmark }}
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>Address</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            {{
                                                delivery_commitment.delivery_address
                                            }}
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>Pincode</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            {{ delivery_commitment.pincode }}
                                        </h5>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div
                                        class="col-sm-12"
                                        style="
                                            border-bottom: 2px dotted darkred !important;
                                        "
                                    ></div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>DO/SO/RECEIPT/DC Number:</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            {{ delivery_commitment.receipt_no }}
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h4>Payment Status:</h4>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4
                                            v-if="
                                                delivery_commitment.pending_amount !=
                                                delivery_commitment.collected_amount
                                            "
                                        >
                                            <b>PENDING</b>
                                        </h4>
                                        <h4
                                            v-if="
                                                delivery_commitment.pending_amount ==
                                                delivery_commitment.collected_amount
                                            "
                                        >
                                            <b>COMPLETED</b>
                                        </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h4>Total Amount</h4>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4>
                                            {{
                                                delivery_commitment.total_amount
                                            }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>Collected Amount</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5>
                                            {{
                                                delivery_commitment.collected_amount
                                            }}
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h4>Pending Amount</h4>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4>
                                            {{
                                                delivery_commitment.pending_amount
                                            }}
                                        </h4>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div
                                        class="col-sm-12"
                                        style="
                                            border-bottom: 2px dotted darkred !important;
                                        "
                                    ></div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h3>Delivery Status</h3>
                                    </div>
                                    <div class="col-sm-6">
                                        <h3>
                                            <b>{{
                                                delivery_commitment.delivery_status
                                            }}</b>
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>Installation Required?</h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <h5
                                            v-if="
                                                delivery_commitment.installation_required ==
                                                true
                                            "
                                        >
                                            YES
                                        </h5>
                                        <h5
                                            v-if="
                                                delivery_commitment.installation_required !=
                                                true
                                            "
                                        >
                                            NO
                                        </h5>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h6>CREATED BY</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <h6>
                                            {{
                                                delivery_commitment.created_by
                                                    .first_name
                                            }}
                                            {{
                                                delivery_commitment.created_by
                                                    .last_name
                                            }}
                                        </h6>
                                        <h6>
                                            {{
                                                delivery_commitment.created_by
                                                    .phone
                                            }}
                                        </h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h6>UPDATED BY</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <h6
                                            v-if="
                                                delivery_commitment.updated_by !=
                                                null
                                            "
                                        >
                                            {{
                                                delivery_commitment.updated_by
                                                    .first_name
                                            }}
                                            {{
                                                delivery_commitment.updated_by
                                                    .last_name
                                            }}
                                        </h6>
                                        <h6
                                            v-if="
                                                delivery_commitment.updated_by !=
                                                null
                                            "
                                        >
                                            {{
                                                delivery_commitment.updated_by
                                                    .phone
                                            }}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>

                        <div class="row overflow-y hidden-print d-print-none">
                            <table
                                class="table table-striped table-bordered table-hover overflow-auto"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col" style="width: 15%">
                                            Buyback Status
                                        </th>
                                        <th scope="col" style="width: 20%">
                                            Payment Status
                                        </th>
                                        <th scope="col" style="width: 15%">
                                            DC No.
                                        </th>
                                        <th scope="col" style="width: 25%">
                                            Invoice & Ewaybill
                                        </th>
                                        <th scope="col" style="width: 15%">
                                            Manage
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <p
                                                v-if="
                                                    delivery_commitment.buyback_collected !=
                                                    true
                                                "
                                            >
                                                <b>PENDING</b>
                                            </p>
                                            <p
                                                v-if="
                                                    delivery_commitment.buyback_collected ==
                                                    true
                                                "
                                            >
                                                <b>COMPLETED</b>
                                            </p>
                                            <button
                                                class="btn btn-primary"
                                                v-if="
                                                    delivery_commitment.buyback_collected !=
                                                    true
                                                "
                                                @click="
                                                    updateBuybackStatusModalPrompt(
                                                        delivery_commitment
                                                    )
                                                "
                                            >
                                                Update Buyback
                                            </button>
                                        </td>
                                        <td>
                                            <p
                                                v-if="
                                                    delivery_commitment.pending_amount !=
                                                    delivery_commitment.collected_amount
                                                "
                                            >
                                                Payment Status:<b>PENDING</b>
                                            </p>
                                            <p
                                                v-if="
                                                    delivery_commitment.pending_amount ==
                                                    delivery_commitment.collected_amount
                                                "
                                            >
                                                Payment Status:<b>COMPLETED</b>
                                            </p>
                                            <p
                                                v-if="
                                                    delivery_commitment.total_amount !=
                                                    null
                                                "
                                            >
                                                Total Amount:
                                                <b>{{
                                                    delivery_commitment.total_amount
                                                }}</b>
                                            </p>
                                            <p
                                                v-if="
                                                    delivery_commitment.pending_amount !=
                                                    null
                                                "
                                            >
                                                Pending:
                                                <b>{{
                                                    delivery_commitment.pending_amount
                                                }}</b>
                                            </p>
                                            <p
                                                v-if="
                                                    delivery_commitment.collected_amount !=
                                                    null
                                                "
                                            >
                                                Collected:
                                                <b>{{
                                                    delivery_commitment.collected_amount
                                                }}</b>
                                            </p>
                                            <button
                                                class="btn btn-primary"
                                                @click="
                                                    updateCollectedAmountModalPrompt(
                                                        delivery_commitment
                                                    )
                                                "
                                            >
                                                Update Collected Amount
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                class="btn btn-primary"
                                                @click="
                                                    updateDCModalPrompt(
                                                        delivery_commitment
                                                    )
                                                "
                                                v-if="
                                                    delivery_commitment.sale_order_no ==
                                                    null
                                                "
                                            >
                                                Update DC
                                            </button>
                                            <p
                                                v-if="
                                                    delivery_commitment.sale_order_no !=
                                                    null
                                                "
                                            >
                                                <b>{{
                                                    delivery_commitment.sale_order_no
                                                }}</b>
                                            </p>
                                        </td>
                                        <td>
                                            <button
                                                class="btn btn-primary"
                                                @click="
                                                    updateInvoiceModalPrompt(
                                                        delivery_commitment
                                                    )
                                                "
                                                v-if="
                                                    delivery_commitment.invoice_no ==
                                                    null
                                                "
                                            >
                                                Update Invoice
                                            </button>
                                            <button
                                                class="btn btn-primary"
                                                @click="
                                                    updateEwaybillModalPrompt(
                                                        delivery_commitment
                                                    )
                                                "
                                                v-if="
                                                    delivery_commitment.ewaybill_generated ==
                                                    0
                                                "
                                            >
                                                Update E-waybill
                                            </button>
                                            <p
                                                v-if="
                                                    delivery_commitment.invoice_no !=
                                                    null
                                                "
                                            >
                                                Invoice No:
                                                <b>{{
                                                    delivery_commitment.invoice_no
                                                }}</b>
                                            </p>
                                            <p
                                                v-if="
                                                    delivery_commitment.invoice_no !=
                                                    null
                                                "
                                            >
                                                Invoice Date:
                                                <b>{{
                                                    delivery_commitment.invoice_date
                                                }}</b>
                                            </p>
                                            <p
                                                v-if="
                                                    delivery_commitment.ewaybill_no !=
                                                    null
                                                "
                                            >
                                                Ewaybill No:
                                                <b>{{
                                                    delivery_commitment.ewaybill_no
                                                }}</b>
                                            </p>
                                        </td>
                                        <td>
                                            <div class="col-sm-12">
                                                <div class="row">
                                                    <button
                                                        class="btn btn-primary"
                                                        @click="
                                                            updateConfirmedDeliveryDateModalPrompt(
                                                                delivery_commitment
                                                            )
                                                        "
                                                        v-if="
                                                            delivery_commitment.confirmed_delivery_date ==
                                                            null
                                                        "
                                                    >
                                                        Update Confirmed Date
                                                    </button>
                                                </div>
                                                <br />
                                                <div class="row">
                                                    <button
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        class="btn btn-danger"
                                                        @click="
                                                            updateStatusModalPrompt(
                                                                delivery_commitment
                                                            )
                                                        "
                                                    >
                                                        Change Status
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style="break-after: page"></div>
                        <br />
                        <br />
                        <div class="row">
                            <img
                                :src="delivery_commitment.gatepass_image"
                                width="auto"
                                height="900"
                                @click="viewImage()"
                            />
                        </div>
                        <div
                            v-if="delivery_commitment.receipt_no != null"
                            style="break-after: page"
                        ></div>
                        <br />
                        <br />
                        <div
                            v-if="delivery_commitment.receipt_no != null"
                            class="row"
                        >
                            <img
                                :src="delivery_commitment.receipt_image"
                                width="auto"
                                height="900"
                                @click="viewImage()"
                            />
                        </div>
                    </div>
                </div>

                <!-- </div> -->
            </div>
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                id="receiptImageModal"
            >
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Receipt Image</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <img
                                :src="receipt_image"
                                width="700"
                                height="700"
                                @click="viewImage()"
                            />
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                id="gatepassImageModal"
            >
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Gatepass Image</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <img
                                :src="gatepass_image"
                                width="700"
                                height="700"
                                @click="viewImage()"
                            />
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal" tabindex="-1" role="dialog" id="updateDCModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Update DC Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Sales DC No:
                                </span>
                                <input
                                    type="text"
                                    v-model="sale_order_no"
                                    placholder="Enter the sale order number"
                                    class="form-control"
                                />
                            </div>
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Sales DC Date:
                                </span>
                                <input
                                    type="date"
                                    v-model="sale_order_date"
                                    placholder="Enter the sale order date"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="updateDC"
                            >
                                Update DC Info
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                id="updateInvoiceModal"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Update Invoice Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Invoice No:
                                </span>
                                <input
                                    type="text"
                                    v-model="invoice_no"
                                    placholder="Enter the invoice number"
                                    class="form-control"
                                />
                            </div>
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Invoice Date:
                                </span>
                                <input
                                    type="date"
                                    v-model="invoice_date"
                                    placholder="Enter the invoice date"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="updateInvoice"
                            >
                                Update Invoice Info
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                id="updateEwaybillModal"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Update Ewaybill Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Enter Ewaybill number
                                </span>
                                <input
                                    type="text"
                                    v-model="ewaybill_no"
                                    placholder="Enter the Ewaybill number"
                                    class="form-control"
                                />
                            </div>
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Enter Ewaybill Date
                                </span>
                                <input
                                    type="date"
                                    v-model="ewaybill_date"
                                    placholder="Enter the Ewaybill date"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="updateEwaybill"
                            >
                                Update Ewaybill Info
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                id="updateConfirmedDeliveryDateModal"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                Update Confirmed Delivery Date
                            </h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Enter Confirmed Delivery Date:
                                </span>
                                <input
                                    type="date"
                                    v-model="confirmed_delivery_date"
                                    placholder="Enter the confirmed delivery date"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="updateConfirmedDeliveryDate"
                            >
                                Give
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                id="updateBuybackStatusModal"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Update Buyback Status</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Is Buyback collected?
                                </span>
                                <label>
                                    <input
                                        v-model="buyback_collected"
                                        name="buyback_collected"
                                        type="radio"
                                        autocomplete="off"
                                        v-bind:value="'1'"
                                        checked
                                    />
                                    Collected
                                </label>
                                <label>
                                    <input
                                        v-model="buyback_collected"
                                        name="buyback_collected"
                                        type="radio"
                                        autocomplete="off"
                                        v-bind:value="'0'"
                                        checked
                                    />
                                    Not Collected
                                </label>
                            </div>

                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Buyback Details:</span
                                >
                                <input
                                    type="text"
                                    placeholder="Enter the Buyback Details"
                                    style="width: 100% !important"
                                    v-model="buyback_details"
                                    class="form-control"
                                    required
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="updateBuyback"
                            >
                                Update
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                id="updateCollectedAmountModal"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Update Collected Amount</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>Total Amount: {{ total_amount }}</p>
                            <p>Pending Amount: {{ pending_amount }}</p>
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Collected Amount:</span
                                >
                                <input
                                    type="number"
                                    v-model="collected_amount"
                                    placholder="Enter the collected amount"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="updateCollectedAmount"
                            >
                                Update
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                id="updateStatusModal"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Update DC Status</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Pick Status:</span
                                >
                                <select
                                    v-model="delivery_status"
                                    style="width: 100% !important"
                                    class="form-control"
                                >
                                    <option
                                        v-for="j in delivery_status_list"
                                        :key="j.id"
                                        :value="j.status"
                                    >
                                        {{ j.status }}
                                    </option>
                                    <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                </select>
                            </div>
                            <div class="form-group">
                                <span class="right badge badge-secondary"
                                    >Notes:
                                </span>
                                <input
                                    type="text"
                                    v-model="notes"
                                    placholder="Enter notes if any"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="updateDCStatus"
                            >
                                Update
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: {
        pagination: Pagination,
    },

    created() {
        this.getDeliveryRoutes();
        this.getDeliveryItemCategories();
        this.getDeliveryStatusList();
        this.getDeliveryCommitment();
        this.getDeliveryStatusTimeline();
    },

    data() {
        return {
            delivery_routes: [],
            delivery_commitment: [],
            delivery_item_categories: [],
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            route: "",
            description: "",
            dc_status: "",
            delivery_status: "",
            delivery_status_list: "",
            confirmed_delivery_date: "",
            notes: "",
            dc_id: "",
            sale_order_no: "",
            sale_order_date: "",
            invoice_no: "",
            invoice_date: "",
            ewaybill_no: "",
            ewaybill_date: "",
            total_amount: "",
            pending_amount: "",
            receipt_image: "",
            gatepass_image: "",
            buyback_collected: "",
            buyback_details: "",
            collected_amount: "",
            item_category: [],
            delivery_route: [],
            delivery_status_timeline: [],

            params: new Form({
                sap_pushed: null,
                customer_type: null,
                delivery_mode: null,
                phone: null,
                gatepass: null,
                from_date: null,
                to_date: null,
                source: null,
                order_id: null,
                payment_mode: null,
                finance_mode: null,
                payment_status: null,
                branch: null,
            }),
        };
    },

    methods: {
        print() {
            const prtHtml = document.getElementById("print").innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = "";
            for (const node of [
                ...document.querySelectorAll('link[rel="stylesheet"], style'),
            ]) {
                stylesHtml += node.outerHTML;
            }

            // Open the print window
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
            );

            WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            // WinPrint.close();
        },

        exportToPDF() {
            html2pdf(document.getElementById("element-to-convert"), {
                margin: 1,
                filename: "i-was-html.pdf",
            });
        },

        receiptImageModalPrompt(dc) {
            this.dc_id = dc.id;
            this.receipt_image = dc.receipt_image;
            $("#receiptImageModal").modal("show");
        },
        gatepassImageModalPrompt(dc) {
            this.dc_id = dc.id;
            this.gatepass_image = dc.gatepass_image;
            $("#gatepassImageModal").modal("show");
        },
        updateBuybackStatusModalPrompt(dc) {
            this.dc_id = dc.id;
            this.buyback_collected = dc.buyback_collected;
            this.buyback_details = dc.buyback_details;
            $("#updateBuybackStatusModal").modal("show");
        },
        updateBuyback() {
            axios
                .post("/api/markBuybackCollection", {
                    id: this.dc_id,
                    buyback_collected: this.buyback_collected,
                    buyback_details: this.buyback_details,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Buyback Info Updated!",
                    });
                    $("#updateBuybackStatusModal").modal("hide");
                    this.getDeliveryCommitment();
                });
        },
        updateCollectedAmountModalPrompt(dc) {
            this.dc_id = dc.id;
            this.total_amount = dc.total_amount;
            this.pending_amount = dc.pending_amount;
            this.collected_amount = dc.collected_amount;
            $("#updateCollectedAmountModal").modal("show");
        },
        updateCollectedAmount() {
            axios
                .post("/api/updateDCCollectedAmount", {
                    id: this.dc_id,
                    collected_amount: this.collected_amount,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Collected Amount Updated!",
                    });
                    $("#updateCollectedAmountModal").modal("hide");
                    this.getDeliveryCommitment();
                    this.getDeliveryStatusTimeline();
                });
        },
        updateDCModalPrompt(dc) {
            this.dc_id = dc.id;
            $("#updateDCModal").modal("show");
        },
        updateDC() {
            axios
                .post("/api/updateSalesDCInfo", {
                    id: this.dc_id,
                    sale_order_no: this.sale_order_no,
                    sale_order_date: this.sale_order_date,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "DC Details Updated!",
                    });
                    $("#updateDCModal").modal("hide");
                    this.getDeliveryCommitment();
                    this.getDeliveryStatusTimeline();
                });
        },
        updateInvoiceModalPrompt(dc) {
            this.dc_id = dc.id;
            $("#updateInvoiceModal").modal("show");
        },
        updateInvoice() {
            axios
                .post("/api/updateInvoiceInfo", {
                    id: this.dc_id,
                    invoice_no: this.invoice_no,
                    invoice_date: this.invoice_date,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Invoice Details Updated!",
                    });
                    $("#updateInvoiceModal").modal("hide");
                    this.getDeliveryCommitment();
                });
        },
        updateEwaybillModalPrompt(dc) {
            this.dc_id = dc.id;
            $("#updateEwaybillModal").modal("show");
        },
        updateEwaybill() {
            axios
                .post("/api/updateEwaybillInfo", {
                    id: this.dc_id,
                    ewaybill_no: this.ewaybill_no,
                    ewaybill_date: this.ewaybill_date,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Ewaybill Details Updated!",
                    });
                    $("#updateEwaybillModal").modal("hide");
                    this.getDeliveryCommitment();
                });
        },
        updateConfirmedDeliveryDateModalPrompt(dc) {
            this.dc_id = dc.id;
            $("#updateConfirmedDeliveryDateModal").modal("show");
        },
        updateConfirmedDeliveryDate() {
            axios
                .post("/api/updateConfirmedDeliveryDate", {
                    id: this.dc_id,
                    confirmed_delivery_date: this.confirmed_delivery_date,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Confirmed Delivery Date Updated!",
                    });
                    $("#updateConfirmedDeliveryDateModal").modal("hide");
                    this.getDeliveryCommitment();
                });
        },
        updateStatusModalPrompt(dc) {
            this.dc_id = dc.id;
            // this.allotment_id = allotment.id;
            // this.title = "A "+allotment.gift_rule.assigned_gift+" is given to "+allotment.gift_registration.first_name+" "+allotment.gift_registration.last_name+", "+allotment.phone;
            $("#updateStatusModal").modal("show");
        },
        updateDCStatus() {
            axios
                .post("/api/updateDCStatus", {
                    id: this.dc_id,
                    delivery_status: this.delivery_status,
                    notes: this.notes,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "DC Status Updated!",
                    });
                    $("#updateStatusModal").modal("hide");
                    this.getDeliveryCommitment();
                    this.getDeliveryStatusTimeline();
                });
        },

        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getDeliveryRoutes() {
            axios.post("/api/getDeliveryRoutes").then((response) => {
                this.delivery_routes = response.data;
            });
        },

        getDeliveryStatusList() {
            axios.post("/api/getDeliveryStatusList").then((response) => {
                this.delivery_status_list = response.data;
            });
        },

        getDeliveryStatusTimeline() {
            axios
                .post("/api/getDCStatusHistory", { id: this.$route.params.id })
                .then((response) => {
                    this.delivery_status_timeline = response.data.data;
                });
        },

        getDeliveryItemCategories() {
            axios.post("/api/getDeliveryItemCategories").then((response) => {
                this.delivery_item_categories = response.data;
            });
        },

        getDeliveryCommitment() {
            axios
                .post("/api/getDeliveryCommitment", {
                    id: this.$route.params.id,
                })
                .then((response) => {
                    this.delivery_commitment = response.data;
                    this.item_category =
                        this.delivery_commitment.master_delivery_item_category;
                    this.delivery_route =
                        this.delivery_commitment.master_delivery_route;
                });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        addMasterDeliveryRoute() {
            axios
                .post("/api/addMasterDeliveryRoute", {
                    branch_code: this.branch_code,
                    route: this.route,
                    description: this.description,
                })
                .then(() => {
                    this.getMasterDeliveryRoutes();
                    toast.fire({
                        title: "Added",
                        icon: "success",
                    });
                })
                .catch(() => {
                    toast.fire({
                        title: "Failed! Input Valid Date",
                        icon: "error",
                    });
                });
        },

        changeStatus(id) {
            axios
                .post("/api/updateMasterDeliveryRoute", { id: id })
                .then(() => {
                    this.getMasterDeliveryRoutes();
                })
                .catch(() => {
                    toast.fire({
                        title: "Failed!",
                        icon: "error",
                    });
                });
        },

        deleteRoute(id) {
            axios
                .post("/api/deleteMasterDeliveryRoute", { id: id })
                .then(() => {
                    this.getLinkages();
                })
                .catch(() => {
                    toast.fire({
                        title: "Failed!",
                        icon: "error",
                    });
                });
        },
    },
};
</script>
